export default __webpack_public_path__ + "static/testimonialHolder7-8d1a1880ef5d439ab17ab47fadcd477d.png";